/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { db_DropdownStipendAwardFunding } from '../models/db_DropdownStipendAwardFunding';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class StipendAwardFundings {
    /**
     * Get a list of stipend award fundings
     * @returns db_DropdownStipendAwardFunding OK
     * @throws ApiError
     */
    public static listStipendAwardFundings(): CancelablePromise<Array<db_DropdownStipendAwardFunding>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/stipend-award-fundings',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
}
